"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tumblr;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Tumblr(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Tumblr"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "tumblr",
    className: "cls-1",
    d: "M73.408,85.047C71.283,87.312,65.6,90,58.189,90,39.314,90,35.22,76.125,35.22,68.031v-22.5H27.8a1.567,1.567,0,0,1-1.562-1.562V33.344A2.645,2.645,0,0,1,28,30.844c9.688-3.407,12.735-11.875,13.172-18.3C41.3,10.828,42.189,10,43.689,10H54.767a1.567,1.567,0,0,1,1.562,1.562v18H69.3a1.554,1.554,0,0,1,1.563,1.547V43.875A1.567,1.567,0,0,1,69.3,45.437H56.267V66.25c0,5.344,3.7,8.375,10.625,5.594a3.293,3.293,0,0,1,1.984-.344,1.688,1.688,0,0,1,1.157,1.234L73.47,82.781c.281.781.516,1.656-.062,2.266Z"
  })));
}